/* eslint-disable react/prop-types */

import {
    Box,
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
    Card,
    CardContent,
    CardActions,
    IconButton,
    Chip
} from '@mui/material';
import { PaeServices } from '../../../services/api/action-plan/Pae';
import { useNavigate } from 'react-router-dom';
import { Delete, Edit } from '@mui/icons-material';
import { ConfirmationDialog } from '../../shared';
import { useState } from 'react';
import { IEmergencySimulation } from '../../../services/api/action-plan/EmergencySimulation';


interface TableSimulationProps {
    data: IEmergencySimulation[],
    onDelet: () => void,
    permissions?: string,
}

export const TableSimulation = ({ data, onDelet, permissions = '' }: TableSimulationProps) => {

    const navigate = useNavigate();
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const handleDelet = (uuid: string | undefined) => {
        if (uuid !== undefined) {
            PaeServices.delet(uuid)
                .then((response) => {
                    if (response instanceof Error) {
                        console.log(response.message);
                    } else {
                        console.log(response);
                        onDelet();
                    }
                });
        }
    };

    const [valueId, setValueID] = useState<string | undefined>(undefined);
    const [isDialogOpen, setDialogOpen] = useState(false);

    const toggleDialog = () => {
        setDialogOpen(!isDialogOpen);
    };

    const handleClickOpen = (key: string | undefined | null) => {
        if (key !== undefined && key !== null) {
            setValueID(key);
            toggleDialog();
        }
    };

    const MobileSimulationCard = ({ item, permissions, handleClickOpen, navigate }: {
        item: IEmergencySimulation;
        permissions: string;
        handleClickOpen: (key: string | undefined | null) => void;
        navigate: ReturnType<typeof useNavigate>;
    }) => (
        <Card variant="outlined" sx={{ mb: 2, borderRadius: '15px' }}>
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ wordBreak: 'break-word', flex: 1, mr: 1, fontSize: smDown ? '1rem' : '1.125rem' }}
                    >
                        Simulação de Emergência
                    </Typography>
                    {item.data_simulado && (
                        <Chip
                            label={`Ref: ${item.data_simulado}`}
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{ flexShrink: 0 }}
                        />
                    )}
                </Box>
                {item.data_simulado && (
                    <Typography
                        variant="body2"
                        component="div"
                        color="text.secondary"
                        sx={{ wordBreak: 'break-word', fontSize: smDown ? '0.8rem' : '0.875rem', mb: item.instituicoes_participantes ? 1 : 0 }}
                    >
                        <Typography component="span" fontWeight="bold">Data da Simulação:</Typography> {item.data_simulado}
                    </Typography>
                )}
                {item.instituicoes_participantes && (
                    <Typography
                        variant="body2"
                        component="div"
                        color="text.secondary"
                        sx={{ wordBreak: 'break-word', fontSize: smDown ? '0.8rem' : '0.875rem' }}
                    >
                        <Typography component="span" fontWeight="bold">Instituições:</Typography> {item.instituicoes_participantes}
                    </Typography>
                )}
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end', p: 2, pt: 0, flexDirection: 'column', gap: 1 }}>
                <Button
                    sx={{ borderRadius: '35px' }}
                    variant='outlined'
                    startIcon={<Edit />}
                    color='success'
                    onClick={() => navigate(`detalhes/${item.uuid}`)}
                    disabled={!permissions?.includes('edit') || !permissions?.includes('view')}
                    fullWidth
                >
                    Editar
                </Button>
                <Button
                    sx={{ borderRadius: '35px' }}
                    variant='outlined'
                    startIcon={<Delete />}
                    color='error'
                    onClick={() => handleClickOpen(item.uuid)}
                    disabled={!permissions.includes('remove')}
                    fullWidth
                >
                    Remover
                </Button>
            </CardActions>
        </Card>
    );

    return (
        <Box component={Paper} variant='outlined' sx={{ borderRadius: '25px', overflowX: 'auto' }} flex={1} width={'100%'} p={smDown ? 1 : 1}>
            <Typography variant={smDown ? 'h6' : 'h5'} align={smDown ? 'center' : 'left'} mb={2}>
                Simulações de Emergência
            </Typography>

            {smDown ? (
                data.length > 0 ? (
                    data.map((item, index) => (
                        <MobileSimulationCard
                            key={item.uuid || index}
                            item={item}
                            permissions={permissions}
                            handleClickOpen={handleClickOpen}
                            navigate={navigate}
                        />
                    ))
                ) : (
                    <Paper sx={{ p: 3, textAlign: 'center', borderRadius: '15px' }}>
                        <Typography color="text.secondary">
                            Nenhum resultado encontrado
                        </Typography>
                    </Paper>
                )
            ) : (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center'>Data simulado</TableCell>
                            <TableCell align='center'>Instituições</TableCell>
                            <TableCell align='center'>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, index) =>
                            <TableRow key={item.uuid || index}>
                                <TableCell align='center'><Typography>{item.data_simulado}</Typography></TableCell>
                                <TableCell align='center'><Typography>{item.instituicoes_participantes}</Typography></TableCell>
                                <TableCell align='center'>
                                    <Box
                                        display={'flex'}
                                        justifyContent={'center'}
                                        gap={1}
                                    >
                                        <IconButton
                                            color='success'
                                            onClick={() => navigate(`detalhes/${item.uuid}`)}
                                            disabled={!permissions?.includes('edit') || !permissions?.includes('view')}
                                        >
                                            <Edit />
                                        </IconButton>
                                        <IconButton
                                            color='error'
                                            onClick={() => handleClickOpen(item.uuid)}
                                            disabled={!permissions.includes('remove')}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {data.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={3} align="center">
                                    <Typography component="span" color="text.secondary">
                                        Nenhum resultado encontrado
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            )}
            <ConfirmationDialog
                isOpen={isDialogOpen}
                onClose={toggleDialog}
                onConfirm={() => handleDelet(valueId)}
                title='Excluir Arquivo'
                message='Tem certeza que deseja excluir o documento?'
            />
        </Box>
    );
};